import { Contract } from '../types/contract';
import { Language } from '../types/language';
import { Port, PortSelectItem } from '../types/port';

export const renderPortName = (port: Port, language: Language): string =>
  `${port.islandNames[language]} - ${port.names[language]}`;

export const renderPortSelectItemLabel = (
  port: PortSelectItem,
  t: (stringId: string) => string,
) => port.label + (port.issue ? ` (${t(`content.${port.issue}`)})` : '');

export const prepareAllowedPorts = (
  ports: PortSelectItem[],
  contract: Contract,
) => {
  const allowedPorts: PortSelectItem[] = [];
  const allowedPortsMap: Record<string, PortSelectItem> = {};

  const allowedPortsIdsSet = new Set(contract.allowedPorts);

  ports.forEach(port => {
    const isAllowed = allowedPortsIdsSet.has(port.value);
    const selectItem: PortSelectItem = isAllowed
      ? port
      : { ...port, issue: 'unallowed' };

    if (!selectItem.issue) {
      allowedPorts.push(selectItem);
    }
    allowedPortsMap[selectItem.value] = selectItem;
  });

  return {
    allowedPorts,
    allowedPortsMap,
    defaultDeparturePort:
      allowedPortsMap[contract.defaultPortOfDepartureId] ?? null,
    defaultArrivalPort:
      allowedPortsMap[contract.defaultPortOfArrivalId] ?? null,
  };
};
